import { LANGUAGE } from 'shared-components';

import { removeTrailingSlash } from '../kh-utils/kh-utils';

import { environment } from 'env/environment';

export function buildLocaleUrl(localeId: string): string {
  const supportedLanguages = [
    getLangPart(LANGUAGE.FRENCH_CANADA),
    getLangPart(LANGUAGE.SPANISH_MEXICO),
    getLangPart(LANGUAGE.PORTUGUESE_PORTUGAL)
  ];
  const localeLanguage = getLangPart(localeId);

  const url = window.location.href;
  const host = window.location.host;
  const currentDomain = window.location.protocol + '//' + host;
  let urlWithoutDomain = url.replace(currentDomain, '');

  const baseUrl = removeTrailingSlash(environment.AppBaseHref);

  const toReplace = baseUrl + '(?:/(?:es|fr|pt))?';
  const replacement = baseUrl + (supportedLanguages.includes(localeLanguage) ? '/' + localeLanguage : '');
  urlWithoutDomain = urlWithoutDomain.replace(
    new RegExp(toReplace), replacement);

  return currentDomain + urlWithoutDomain;
}

export function buildLocaleUrlForLanguage(targetUrl: string, localeId: string): string {
  const supportedLanguages = [
    getLangPart(LANGUAGE.FRENCH_CANADA),
    getLangPart(LANGUAGE.SPANISH_MEXICO),
    getLangPart(LANGUAGE.PORTUGUESE_PORTUGAL)
  ];
  const localeLanguage = getLangPart(localeId);

  const host = window.location.host;
  const currentDomain = window.location.protocol + '//' + host;

  const baseUrl = removeTrailingSlash(environment.AppBaseHref);
  const baseAndNew = baseUrl + targetUrl;
  const toReplace = baseUrl + '(?:/(?:es|fr|pt))?';
  const replacement = baseUrl + (supportedLanguages.includes(localeLanguage) ? '/' + localeLanguage : '');
  const newUrl = baseAndNew.replace(new RegExp(toReplace), replacement);

  return currentDomain + newUrl;
}

export function getLangPart(localeId: string) {
  return localeId.substring(0, localeId.indexOf('-'));
}

export function buildLocatedFileUrl(url: string, localeId: string): string {
  const lang = getLangPart(localeId);

  return lang
    ? url.replace(/\.(\w+)$/, `_${lang}.$1`)
    : url;
}
